<template>
  <RouterView/>
</template>

<script>
import { CenterScale, defaultFocusModel } from "vue-niney";

export default {
  name: "App",
  created() {
    defaultFocusModel.minScale = 3466752.130657345;
    defaultFocusModel.setCenterScale(new CenterScale(1700000, 2500000, 55468034.09051751));
  }
}
</script>

<style lang="scss">
$primary: #289ceb;
@import "~bootstrap/scss/bootstrap";

$fa-font-path: "~@fortawesome/fontawesome-free/webfonts";
@import "~@fortawesome/fontawesome-free/scss/fontawesome";
@import "~@fortawesome/fontawesome-free/scss/solid";

html, body, #app {
  height: 100%;
  margin: 0;
}
</style>
